export default "__VITE_ASSET__vWQSbDeY__"